import Link from 'next/link';

import { Grid, Typography, Button, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';
import { Section } from '@/src/components/organisms';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.primary.main,
  },
  hero: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  section: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  textWhite: {
    color: 'white',
  },
  image: {
    marginTop: theme.spacing(4),
  },
}));

const Solutions = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Section className={classes.hero}>
        <Grid container>
          <Grid item xs={12} md={6} data-aos="fade-up">
            <Section className={classes.section}>
              <>
                <Typography variant="h6" component="div" gutterBottom className={classes.textWhite}>
                  ALL IN ONE
                </Typography>
                <SectionHeader
                  title={
                    <span className={classes.textWhite}>
                      Tenha tudo que precisa para vender online em uma única plataforma
                    </span>
                  }
                  subtitle={
                    <span className={classes.textWhite}>
                      Nossa plataforma se adapta a diversas necessidades e cenários simples ou
                      complexos de venda online para instituições de ensino ou fornecedores
                      educacionais. Conte com uma experiência integrada com atendimento, tecnologia
                      de e-commerce, meio de pagamento integrado e gestão completa.
                    </span>
                  }
                  ctaGroup={[
                    <Link href="/solutions" passHref key="solutionsCta">
                      <Button
                        variant="contained"
                        size="large"
                        color="secondary"
                        component="a"
                        aria-label="Soluções">
                        Soluções
                      </Button>
                    </Link>,
                  ]}
                  align="left"
                  data-aos="fade-up"
                />
              </>
            </Section>
          </Grid>
          {isMd ? (
            <Grid item xs={12} md={6}>
              <Image
                src="/images/illustrations/platform/feature-3.svg"
                width="100%"
                className={classes.image}
                alt="Mulher visualizando soluções da Eskolare"
              />
            </Grid>
          ) : null}
        </Grid>
      </Section>
    </div>
  );
};

Solutions.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Solutions;
